import { ExpandMore } from "@mui/icons-material";
import { Button, Menu, MenuItem, useTheme } from "@mui/material";
import React from "react";
import CustomCheckBox from "../../../../components/customCheckBox";

const BulkSelectCheckBox = ({
  selected,
  setSelected,
  totalAccounts,
  accounts
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        endIcon={<ExpandMore />}
        onClick={handleClick}
        disableRipple
        sx={{
          p: 0,
          borderRadius: 1,
          border: `1px solid ${theme.palette.grey[400]}`,
          color: "inherit",
          "&:hover": {
            backgroundColor: "transparent",
          },
          "& .MuiButton-endIcon": {
            m: 0,
            ml: "-4px",
          },
        }}
        disabled={!Boolean(totalAccounts)}
      >
        <CustomCheckBox
          checked={
            selected?.length > 0 && selected?.length === Number(totalAccounts)
          }
          disableRipple
        />
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiMenu-list": { p: 0 },
          "& .MuiPopover-paper": {
            minWidth: "270px",
          },
          "& .MuiMenuItem-root": {
            borderBottom: `1px solid rgba(255, 255, 255, 0.3)`,
            py: 1.5,
            fontSize: "14px",
            fontWeight: 500,
            "&:last-child": {
              borderBottom: "none",
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            const accIds = accounts?.map((mem) => mem?._id);
            setSelected(accIds);
            handleClose();
          }}
        >
          Select this page
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            const accIds = allAccounts?.map((mem) => mem?._id);
            setSelected(accIds);
            handleClose();
          }}
        >
          Select all leads
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            setSelected([]);
            handleClose();
          }}
        >
          Clear selection
        </MenuItem>
      </Menu>
    </>
  );
};

export default BulkSelectCheckBox;
